import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Layout,
  Modal,
  Row,
  Select,
  Table,
  TableProps
} from "antd";
import { ColumnsType } from "antd/es/table";
import { get, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import ActionContent from "src/components/common/ActionContent";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  checkVaiTroUserLogin,
  getLocalStorage,
  listTrangThai,
  reDataForTable,
  renderTrangThai,
  setLocalStorage
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

import {
  PlusOutlined,
  SendOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import { selectData } from "src/appRedux/reducers/commonApiReducer";

const FormItem = Form.Item;
type TableRowSelection<T> = TableProps<T>["rowSelection"];

interface NhomTaiLieu {
  id: number;
  tenNhomTuLieu: string;
}

const DanhSachHinhAnh = ({ status, formRef }: any) => {
  const useInfo = useAppSelector(selectUser);
  const [form] = Form.useForm();
  const { isActive, isAdmin } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [listLoaiTaiLieu, setListLoaiTaiLieu] = useState([]);
  const [isLoadLoaiBaoCao, setIsLoadLoaiBaoCao] = useState(false);
  const [isSearchClick, setIsSearchClick] = useState(false);
  const pageSize = 10;
  const navigate = useNavigate();
  const { resetFields } = form;
  const [listNguoiDung, setListNguoiDung] = useState([]);
  const [loadingNguoiDung, setLoadingNguoiDung] = useState(false);
  const { idnhomtulieu } = useParams();
  const [tenNhomTuLieu, setTenNhomTuLieu] = useState("");
  const isSoanThao = checkVaiTroUserLogin(useInfo, "SOAN_THAO");
  const isDuyetXuatBan = checkVaiTroUserLogin(useInfo, "DUYET_XUAT_BAN");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [searchParams] = useState({
    idLoaiTuLieu: undefined,
    idNguoiDang: undefined,
    trangThai: undefined,
    keyword: ""
  });
  const listNhomTaiLieu = useAppSelector(selectData)
    .listNhomTaiLieu as NhomTaiLieu[];

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (e) => <span>{e}</span>
    },
    {
      title: "Tên tài liệu",
      dataIndex: "tenTuLieu",
      key: "tenTuLieu",
      render: (text, record) => renderTitle(text, record)
    },
    {
      title: "Tên tác giả",
      dataIndex: "tacGia",
      key: "tacGia",
      width: "15%"
    },
    {
      title: "Người đăng",
      dataIndex: "tenNguoiDang",
      key: "tenNguoiDang",
      width: "15%"
    },
    {
      title: "Trạng thái",
      dataIndex: "trangThai",
      key: "trangThai",
      width: "15%",
      render: (item) => renderTrangThai(item)
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item)
    }
  ];

  const [columsTable, setColumsTable] = useState(columns);

  useEffect(() => {
    if (isActive) {
      const state = getLocalStorage("dataFilter") || undefined;
      if (idnhomtulieu && listNhomTaiLieu) {
        const itemNhomTL =
          listNhomTaiLieu.find(
            (value: any) => value.id === parseInt(idnhomtulieu, 10)
          );
        const tenNhomTuLieu = itemNhomTL ? itemNhomTL.tenNhomTuLieu : "";
        setTenNhomTuLieu(tenNhomTuLieu);
      }
      if (isDuyetXuatBan || isAdmin) {
        columns.push({
          title: "Xuất bản",
          dataIndex: "",
          key: "x",
          align: "center",
          width: "10%",
          render: (item) => actionXuatBan(item)
        });
        setColumsTable(columns);
      }
      if (state) {
        setActivePage(state.activePage);
        getListData(
          state.activePage,
          state.idLoaiTuLieu,
          state.idNguoiDang,
          state.trangThai,
          state.keyword
        );
      } else {
        getListData(
          activePage,
          searchParams.idLoaiTuLieu,
          searchParams.idNguoiDang,
          searchParams.trangThai,
          searchParams.keyword
        );
      }
      getNguoiDung();
      getLoaiTuLieu();
    } else {
      navigate("/error/401");
    }
  }, [idnhomtulieu, listNhomTaiLieu]);

  useEffect(() => {
    return () => {
      cancelListToken([
        "listNguoiDung",
        "listloaitulieus",
        "listLoaiTaiLieu",
        "editTrangThai"
      ]);
    };
  }, []);

  /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof DonThuDaNhapList
   */
  const renderTitle = (text: any, record: any) => (
    <span
      onClick={() => handleRedirect("view", record)}
      style={{ cursor: "pointer", color: "#0065ff" }}
      title="Xem chi tiết"
    >
      {text}
    </span>
  );

  const actionXuatBan = (item: any) => {
    if (isDuyetXuatBan || isAdmin) {
      if (item.trangThai === 2) {
        return (
          <div>
            <Button
              style={{ marginBottom: 5 }}
              className="heading-button-addnew btn"
              type="primary"
              onClick={() => handleGuiDuyet(item, 3)}
              icon={<SendOutlined />}
            >
              Duyệt xuất bản
            </Button>
            <Button
              className="heading-button-addnew btn"
              type="primary"
              onClick={() => handleGuiDuyet(item, 4)}
              icon={<CloseCircleOutlined />}
              color="danger"
              variant="solid"
            >
              Hủy xuất bản
            </Button>
          </div>
        );
      }
      if (item.trangThai === 3) {
        return (
          <Button
            className="heading-button-addnew btn"
            type="primary"
            onClick={() => handleGuiDuyet(item, 4)}
            icon={<CloseCircleOutlined />}
            color="danger"
            variant="solid"
          >
            Hủy xuất bản
          </Button>
        );
      }
    }
    return null;
  };

  const handleGuiDuyet = (item: any, trangThai: number) => {
    Modal.confirm({
      width: 500,
      title: "THÔNG BÁO",
      content: "Bạn sẽ gửi xuất bản tài liệu này. Nhấn Đồng ý để xác nhận.",
      onOk(e) {
        e();
        handleSubmitGui(item, trangThai);
      },
      okText: "Đồng ý",
      onCancel() {},
      cancelText: "Hủy"
    });
  };

  const handleSubmitGui = async (item: any, TT: number) => {
    const configAPI = {
      url: `api/tulieu/${item.id}/${TT}`,
      method: "PUT",
      value: null,
      apiType: "EDIT",
      getName: "editTrangThai"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        getListData(
          activePage,
          searchParams.idLoaiTuLieu,
          searchParams.idNguoiDang,
          searchParams.trangThai,
          searchParams.keyword
        );
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } finally {
    }
  };

  const getNguoiDung = async () => {
    setLoadingNguoiDung(true);
    const configAPI = {
      url: `api/nguoidungs`,
      method: "GET",
      value: null,
      apiType: "LIST",
      params: {
        page: 0
      },
      getName: "listNguoiDung"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response.data, "content", []);
        setListNguoiDung(data);
        setLoadingNguoiDung(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingNguoiDung(false);
      }
    } catch (error) {
      setLoadingNguoiDung(false);
      error;
    }
  };

  /**
   * getListData: danh sách nhóm báo cáo
   * @param {number} activePage
   * @param {number} idNhomTuLieu
   * @param {string} keyword
   * @memberof QuanLyLoaiBaoCao
   */
  const getListData = async (
    activePage: number,
    idLoaiTuLieu: any,
    idNguoiDang: any,
    trangThai: any,
    keyword: string
  ) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/tulieus?page=${activePage}&size=${pageSize}&properties_sort=id&type_sort=desc&ishinhanh=true&idnhomtulieu=${idnhomtulieu}&idloaitulieu=${
        idLoaiTuLieu || 0
      }&idnguoidang=${idNguoiDang || 0}&trangthai=${
        trangThai || 0
      }&keyword=${keyword}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listloaitulieus"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  /**
   * getLoaiTuLieu: Gọi api list nhóm tài liệu
   * @memberof LoaiTaiLieu
   */
  const getLoaiTuLieu = async () => {
    setIsLoadLoaiBaoCao(true);
    const configAPI = {
      url: `api/loaitulieus?keyword&idnhomtulieu=${idnhomtulieu}`,
      method: "GET",
      value: null,
      apiType: "LIST",
      params: {
        page: 0
      },
      getName: "listLoaiTaiLieu"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response.data, "content", []);
        setListLoaiTaiLieu(data);
        setIsLoadLoaiBaoCao(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadLoaiBaoCao(false);
      }
    } catch (error) {
      setIsLoadLoaiBaoCao(false);
      error;
    }
  };

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const actionContent = (item: any) => {
    if ((item.trangThai === 2 || item.trangThai === 3) && isSoanThao) {
      return null;
    }
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemAction = async (item: any) => {
    setIsLoadTable(true);
    const config = {
      url: `api/tulieu/delete/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteLoaiTaiLieu"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage < 0 && total !== 1 ? activePage - 1 : activePage;
        getListData(
          page,
          searchParams.idLoaiTuLieu,
          searchParams.idNguoiDang,
          searchParams.trangThai,
          searchParams.keyword
        );
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      setIsLoadTable(false);
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = `/hinh-anh`;
    const formValues = form.getFieldsValue();
    switch (type) {
      case "new":
        pathname += `/them-moi/idnhomtulieu/${idnhomtulieu}`;
        break;
      case "edit":
        pathname += `/${item.id}/chinh-sua/idnhomtulieu/${idnhomtulieu}`;
        break;
      case "view":
        pathname += `/${item.id}/chi-tiet/idnhomtulieu/${idnhomtulieu}`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });

    if (isSearchClick) {
      const content = {
        keyword: formValues.keyword,
        idLoaiTuLieu: formValues.idLoaiTuLieu,
        activePage,
        pageSize,
        idNguoiDang: formValues.idNguoiDang,
        trangThai: formValues.trangThai
        //   pathname: `${pathName}`
      };
      setLocalStorage("dataFilter", content);
    }
  };

  /**
   * handleTableChange: Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof LoaiTaiLieu
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(
      activePage,
      searchParams.idLoaiTuLieu,
      searchParams.idNguoiDang,
      searchParams.trangThai,
      searchParams.keyword
    );
    setActivePage(activePage);
  };

  /**
   * handleReset: làm mới form tìm kiếm
   * @memberof LoaiTaiLieu
   */
  const handleReset = () => {
    resetFields();
  };

  /**
   * onChange: chọn table
   * @param {Array} newSelectedRowKeys
   * @param {Array} selectedRows
   * @memberof VaiTroForm
   */
  const onChange = (newSelectedRowKeys: any, selectedRows: any) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  /**
   * onChange: chọn table
   * @param {Array} selected
   * @param {Array} selectedRows
   * @memberof VaiTroForm
   */
  const onSelect = (selected: any, selectedRows: any) => {
    setSelectedRowKeys(selected);
  };

  /**
   * rowSelection: Chọn trên bảng
   * @param {object} selectedRowKeys
   * @param {object} selectedRows
   * @memberof VaiTroForm
   */
  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    hideSelectAll: false,
    onChange: onChange,
    onSelect: onSelect
  };

  const onClickDuyetTatCa = async () => {
    try {
      const data = {
        listTuLieuId: [...selectedRowKeys],
        trangThai: 3
      };
      const configAPI = {
        url: `api/tulieu/duyetlist`,
        method: "PUT",
        data: data,
        apiType: "EDIT",
        isShowMessage: true
      };
      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        setLoadingButton(false);
        getListData(
          1,
          searchParams.idLoaiTuLieu,
          searchParams.idNguoiDang,
          searchParams.trangThai,
          searchParams.keyword
        );
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  const onFinish = (values: any) => {
    setIsSearchClick(true);
    getListData(
      activePage,
      values.idLoaiTuLieu,
      values.idNguoiDang,
      values.trangThai,
      values.keyword || ""
    );
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>
          Hình ảnh {tenNhomTuLieu}
        </h3>
        <Button
          className="heading-button-addnew btn"
          type="primary"
          onClick={() => handleRedirect("new", null)}
          icon={<PlusOutlined />}
        >
          Thêm mới
        </Button>
      </Flex>
      <Card>
        <Form
          layout="vertical"
          form={form}
          name="hinhanh-control"
          onFinish={onFinish}
          ref={formRef}
        >
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Loại tài liệu"
                  name="idLoaiTuLieu"
                >
                  <Select
                    ref="idLoaiTuLieu"
                    allowClear
                    loading={isLoadLoaiBaoCao}
                    placeholder="Chọn loại tài liệu"
                    style={{ width: "100%" }}
                    options={listLoaiTaiLieu}
                    fieldNames={{ label: "tenLoaiTuLieu", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Người đăng"
                  name="idNguoiDang"
                >
                  <Select
                    allowClear
                    loading={loadingNguoiDung}
                    placeholder="Chọn người đăng"
                    style={{ width: "100%" }}
                    options={listNguoiDung}
                    fieldNames={{ label: "hoVaTen", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Trạng thái"
                  name="trangThai"
                >
                  <Select
                    allowClear
                    loading={isLoadLoaiBaoCao}
                    placeholder="Chọn trạng thái"
                    style={{ width: "100%" }}
                    options={listTrangThai}
                    fieldNames={{ label: "label", value: "value" }}
                  />
                </FormItem>
              </Col>
              <Col md={6} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Nhập từ khóa"
                  name="keyword"
                >
                  <Input
                    placeholder="Nhập từ khóa..."
                    onPressEnter={onFinish}
                    style={{ width: "100%" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem>
                  <Button
                    type="primary"
                    style={{ marginRight: "10px", backgroundColor: "#0d5ace" }}
                    htmlType="submit"
                  >
                    <div className="content-btn">
                      <span className="name">
                        <SearchOutlined /> Tìm kiếm
                      </span>
                    </div>
                  </Button>
                  <Button onClick={handleReset}>
                    <div className="content-btn">
                      <span className="name">
                        <ReloadOutlined /> Làm mới
                      </span>
                    </div>
                  </Button>
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Form>
        {selectedRowKeys.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: 10
            }}
          >
            <Button
              style={{ background: "green", color: "white" }}
              onClick={onClickDuyetTatCa}
              loading={loadingButton}
            >
              <CheckCircleOutlined /> Duyệt tất cả
            </Button>
          </div>
        )}

        <Table
          rowKey={"id"}
          bordered
          columns={columsTable}
          rowSelection={
            (isDuyetXuatBan || isAdmin) && searchParams.trangThai === 2
              ? rowSelection
              : undefined
          }
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
          scroll={{ x: 800 }}
        />
      </Card>
    </Layout>
  );
};
export default DanhSachHinhAnh;
